import styled from '@emotion/styled';
// Theme 타입을 받아오는 함수 정의 (선택적, 테마 사용 방식에 따라 조정)
const getThemeProp = (prop)=>(props)=>props.theme[prop];
export const FixedInnerSidebar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 68px;
  height: 100vh;
  overflow-y: auto;
  background-color: var(--theme-paper, ${({ theme })=>theme.paper});
  z-index: 10;
  box-sizing: border-box;
  padding: 0;

  @media (min-width: ${({ theme })=>theme.breakpoints.md}) {
    width: 300px;
  }

  @media (min-width: ${({ theme })=>theme.breakpoints.lg}) {
    width: 340px;
  }

  &.vscode-fixed-inner-sidebar {
    body.vscode-dark & {
      background-color: var(--vscode-sideBar-background, var(--theme-paper, ${({ theme })=>theme.paper}));
      color: var(--vscode-sideBar-foreground);
    }
    body.vscode-light & {
      background-color: var(--vscode-sideBar-background, var(--theme-paper, ${({ theme })=>theme.paper}));
      color: var(--vscode-sideBar-foreground);
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  &:not(.vscode-fixed-inner-sidebar)::-webkit-scrollbar {
    width: 4px;
  }
  &:not(.vscode-fixed-inner-sidebar)::-webkit-scrollbar-track {
    background: var(--theme-paper-light, ${({ theme })=>theme.paperLight});
    border-radius: 10px;
  }
  &:not(.vscode-fixed-inner-sidebar) {
    scrollbar-width: thin;
    scrollbar-color: var(--theme-secondary, ${({ theme })=>theme.secondary})
                     var(--theme-paper-light, ${({ theme })=>theme.paperLight});
  }
`;
// --- SidebarToggleButton 스타일 정의 추가 --- 
export const SidebarToggleButton = styled.button`
  position: fixed;
  bottom: 1rem; // 하단에 위치
  left: 1rem; // 좌측에 위치
  z-index: 100; // 다른 요소 위에 보이도록
  padding: var(--theme-spacing-xs, 0.5rem);
  background-color: var(--theme-paper-hover, ${({ theme })=>theme.paperHover});
  border: 1px solid var(--theme-border, ${({ theme })=>theme.border});
  border-radius: var(--theme-radius-md, 0.375rem);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex; // 아이콘 정렬용
  align-items: center;
  justify-content: center;
  color: var(--theme-text, ${({ theme })=>theme.text});
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: var(--theme-paper-active, ${({ theme })=>theme.paperActive});
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  /* 아이콘 크기 및 스타일 */
  svg {
    width: 1.25rem; // 20px
    height: 1.25rem;
  }
`;
export const SidebarActionArea = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ isMobileSidebar, isTabletView })=>isMobileSidebar ? 'flex-start' : isTabletView ? 'center' : 'flex-end'};
  padding: 0.75rem 0;
  margin: 0.5rem 0;
  position: relative;
`;
